import apiClient from "../utils/apiClient";

export const getMarkup = async () => {
    try {
        const response = await apiClient.get(`/sys/markup/hoteleria`)	
        return response?.data;
    } catch (e) {
        throw new Error("error connection", e);  
    }
  }


export const validateCupon = async (data) => {
    try {
        const response = await apiClient.post(`/validate/cupon`, data)	
        return response?.data;
    } catch (e) {
        throw new Error("error connection", e);  
    }
  }